import {axiosApiCallWithToken} from "../axios/customInstance";

import axios from "axios";
import { getAuthToken } from "../axios/tokenManager";
import promise from "q";


export const getDocumentsList = async (userId) => {
    const url = "/list-files?folderPath="+userId;

    try {
        return await axiosApiCallWithToken.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};



export const downloadDocument = async (userId, fileName) => {
    const url = "/download-file?fileName="+userId+'/'+fileName;

    try {
        return await axiosGetFiles.get(url);
    } catch (error) {
        console.log(error);
        return error.response;
    }
};


const axiosGetFiles = axios.create({
    // baseURL: "http://localhost:8085", // no need to set the base url since we have already set the proxy
    baseURL: "https://qkd-webapp-vm.com:8085", // no need to set the base url since we have already set the proxy
    headers: {
      Accept: "application/json, application/pdf, image/png, image/jpeg",
    },
    responseType: 'blob'
  });


  axiosGetFiles.interceptors.request.use(
    (request) => {
      request.headers.Authorization = `Bearer ${getAuthToken()}`;
      console.log(request);
      return request;
    },
    (error) => {
      return promise.reject(error);
    },
  );